// extracted by mini-css-extract-plugin
export default {"topNav":"WQ-z","category":"XQ-z","noArrow":"YQ-z","alternative":"ZQ-z","topLevelNavItem":"_Q-z","navContainer":"aR-z","subcategoryHeading":"bR-z","subcategory":"cR-z"};